import React from 'react';
import classnames from 'classnames';

import { importStatic } from 'utils';

import classes from './index.module.css';

const ROUTES = {
  matches: '/matches/',
  home: '/',
};

const Logo = ({ userLoggedIn }) => {
  const goToMatches = () => {
    window.location.href = ROUTES.matches;
  };

  const goToHome = () => {
    window.location.href = ROUTES.home;
  };

  return (
    <>
      <a
        className="navbar-brand mr-0"
        href={userLoggedIn ? ROUTES.matches : ROUTES.home}
        onClick={userLoggedIn ? goToMatches : goToHome}
      >
        <img
          className={classnames(classes.mobileLogo, 'd-lg-none', {
            'd-block': userLoggedIn,
            'd-none': !userLoggedIn,
          })}
          width="36"
          height="36"
          src={importStatic('/ui-router/images/header/logo_mobile_white.svg')}
          alt="Zippia Official Logo"
        />
        <img
          className={classnames(classes.desktopLogo, 'd-lg-block', {
            'd-none': userLoggedIn,
          })}
          width="160"
          height="36"
          src={importStatic('/ui-router/images/header/logo_white.svg')}
          alt="Zippia Official Logo"
        />
      </a>
    </>
  );
};

export default React.memo(Logo);
